import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
/**
 * 检测是否支持监控某种变化类型
 * @param entryType
 * @returns
 */ export var supportedEntryType = function(entryType) {
    return typeof PerformanceObserver === "function" && Array.isArray(PerformanceObserver.supportedEntryTypes) && PerformanceObserver.supportedEntryTypes.indexOf(entryType) > -1;
};
export var getContainerComponentName = function(element) {
    // 最多向上查找10层
    var maxLevel = 10;
    var level = 0;
    var parent = element;
    while(level < maxLevel){
        var _parent;
        if (parent && typeof parent.getAttribute === "function") {
            var componentName = parent.getAttribute("data-name");
            if (componentName && componentName !== "CnButton") {
                return componentName;
            }
        }
        if (!((_parent = parent) === null || _parent === void 0 ? void 0 : _parent.parentElement)) {
            return "";
        }
        parent = parent.parentElement;
        level++;
    }
    return "";
};
export var mergeAndSliceEventList = function(eventList) {
    var maxLen = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
    var eventMap = {};
    eventList.forEach(function(item) {
        var eventType = item.eventType, target = item.target, componentName = item.componentName;
        var key = "".concat(eventType, "-").concat(target, "-").concat(componentName);
        if (!eventMap[key]) {
            eventMap[key] = [];
        }
        eventMap[key].push(item);
    });
    var mergeList = [];
    Object.keys(eventMap).forEach(function(key) {
        var _Math;
        var list = eventMap[key];
        var durationList = list.map(function(item) {
            return item.duration;
        });
        var firstItem = list[0] || {};
        mergeList.push({
            eventType: firstItem.eventType,
            target: firstItem.target,
            componentName: firstItem.componentName,
            maxDuration: (_Math = Math).max.apply(_Math, _to_consumable_array(durationList)),
            averageDuration: Math.round(durationList.reduce(function(total, duration) {
                return total + duration;
            }, 0) / durationList.length),
            count: durationList.length
        });
    });
    // 返回按照触发次数降序排列的前10个
    return mergeList.sort(function(a, b) {
        return b.count - a.count;
    }).slice(0, maxLen);
};
export function isInDingTalkWebView() {
    // 获取当前浏览器的 User-Agent 字符串
    var userAgent = navigator.userAgent.toLowerCase();
    // 检查 User-Agent 中是否包含 'dingtalk' 字符串
    return userAgent.indexOf("dingtalk") !== -1;
}

 //# sourceMappingURL=utils.js.map